import { render, staticRenderFns } from "./StoreBank.vue?vue&type=template&id=404f514c&scoped=true"
import script from "./StoreBank.vue?vue&type=script&lang=js"
export * from "./StoreBank.vue?vue&type=script&lang=js"
import style0 from "./StoreBank.vue?vue&type=style&index=0&id=404f514c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404f514c",
  null
  
)

export default component.exports